import { render, staticRenderFns } from "./scrollrTab.vue?vue&type=template&id=31f48e76&scoped=true"
import script from "./scrollrTab.vue?vue&type=script&lang=js"
export * from "./scrollrTab.vue?vue&type=script&lang=js"
import style0 from "./scrollrTab.vue?vue&type=style&index=0&id=31f48e76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f48e76",
  null
  
)

export default component.exports